
const ZONE = 'user/'

export const SET_STATU = ZONE + 'SET_STATU'
